'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'light-switch';
var width = 384;
var height = 512;
var aliases = [];
var unicode = 'e017';
var svgPathData = 'M176 48l0-16L32 32l0 448 144 0 0-16 0-16 32 0 0 16 0 16 144 0 0-448L208 32l0 16 0 16-32 0 0-16zM0 0L32 0 352 0l32 0 0 32 0 448 0 32-32 0L32 512 0 512l0-32L0 32 0 0zM96 240l0-112 0-32 32 0 128 0 32 0 0 32 0 112 0 32 0 112 0 32-32 0-128 0-32 0 0-32 0-112 0-32zm32 32l0 112 128 0 0-112-128 0zm0-32l128 0 0-112-128 0 0 112z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faLightSwitch = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;